let swiperThumbs = null;
let swiperMain = null;

// Set when the user activates the prev/next arrows, so focus can be moved
// to the newly active slide (and not on hover / thumbnail changes).
let heroNavUsed = false;

function syncHeroSlidesA11y(swiper) {
  swiper.slides.forEach((slide, i) => {
    const isActive = i === swiper.activeIndex;
    slide.inert = !isActive;
    if (isActive) {
      slide.removeAttribute("aria-hidden");
      slide.setAttribute("tabindex", "-1");
    } else {
      slide.setAttribute("aria-hidden", "true");
      slide.removeAttribute("tabindex");
    }
  });

  if (heroNavUsed) {
    heroNavUsed = false;
    swiper.slides[swiper.activeIndex]?.focus({ preventScroll: true });
  }
}

// THUMBS
document
  .querySelectorAll(".Index_top_hero_slideshows_list_slider")
  .forEach((el) => {
    if (!el.classList.contains("swiper-initialized")) {
      const totalSlides = el.querySelectorAll(".swiper-slide").length;

      swiperThumbs = new Swiper(el, {
        loop: true,
        loopedSlides: totalSlides,
        spaceBetween: 20,
        slidesPerView: 7,
        slideToClickedSlide: true,
        watchSlidesProgress: true,
        direction: "vertical",
        breakpoints: {
          0: {
            spaceBetween: 8,
            slidesPerView: "auto",
            direction: "horizontal",
            freeMode: false, // 🔥 IMPORTANT
          },
          750: {
            spaceBetween: 10,
            slidesPerView: 7,
            direction: "vertical",
          },
          990: {
            spaceBetween: 12,
            slidesPerView: 7,
          },
          1200: {},
          1440: {
            spaceBetween: 20,
          },
        },
      });
    }
  });

// MAIN
document
  .querySelectorAll(".Index_top_hero_slideshows_item_slider")
  .forEach((el) => {
    if (!el.classList.contains("swiper-initialized")) {
      const totalSlides = el.querySelectorAll(".swiper-slide").length;

      swiperMain = new Swiper(el, {
        loop: true,
        loopedSlides: totalSlides,
        slidesPerView: 1,
        effect: "fade",
        speed: 300,
        fadeEffect: {
          crossFade: true,
        },

        // autoplay: {
        //   delay: 7000,
        //   disableOnInteraction: false,
        // },

        autoplay: false,

        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },

        // ✅ let Swiper handle everything
        thumbs: {
          swiper: swiperThumbs,
        },

        // ♿ Only the active slide is exposed to screen readers / keyboard.
        // Hidden slides are inert so focus can't land on them (which would
        // make Swiper's a11y module auto-slide to them).
        on: {
          init: syncHeroSlidesA11y,
          slideChange: syncHeroSlidesA11y,
        },
      });

      // Mouse click and keyboard Enter/Space both go through here
      // (Swiper's a11y keyboard handler doesn't fire navigationNext/Prev).
      el.querySelectorAll(".swiper-button-next, .swiper-button-prev").forEach((btn) => {
        btn.addEventListener("click", () => (heroNavUsed = true), true);
        btn.addEventListener(
          "keydown",
          (e) => {
            if (e.key === "Enter" || e.key === " ") heroNavUsed = true;
          },
          true
        );
      });
    }
  });



// 👇 Hover logic
document
  .querySelectorAll(".Index_top_hero_slideshows_list_slider .swiper-slide")
  .forEach((slide, index) => {
    slide.addEventListener("mouseenter", () => {
      if (swiperMain) {
        swiperMain.slideToLoop(index); // important for loop mode
      }
    });
  });
